// posts/DerbyWeekCelebrate.jsx
import React from "react";
import "../../../css/BlogArticle.css";

export default function DerbyWeekCelebrate() {
  return (
    <div className="blog-article">
      <div className="blog-callout">
        <strong>Quick take:</strong> Derby Week isn’t just Saturday. Do Thurby +
        Oaks, know the hat tradition, and if you’re hosting at home, keep it
        simple (and fun).
      </div>

      <p>
        The bell sounds, the gates swing open, and “they’re off!” The thunderous
        clamoring of horse hooves with thrilled cheering commences — these
        sounds all signal that the long-held tradition of derby season is here.
        The Kentucky Derby is a thoroughbred race held annually at Churchill
        Downs in Louisville on the first Saturday of May. Known as “The Most
        Exciting Two Minutes in Sports” and “The Run for the Roses,” the Derby
        is just one and a quarter miles. This race determines the winner in the
        first leg of the prestigious American Triple Crown and is the number one
        horse race for attendance in North America. It has been running every
        year famously without interruption on the same site since 1875.
      </p>

      <p>
        This time of year there are tons of info on how to navigate and enjoy
        Derby Day at the race, but there are a few other ways to saddle up like
        a local.
      </p>

      <h2>Headed to the Derby? Make a whole weekend of it with Thurby and Oaks!</h2>
      <p>
        Leading up to the excitement of Saturday, Kentucky Derby Week has many
        events that could help you get into the Derby spirit. One such event is
        Thurby— a concert on Thursday afternoon held live in the infield at
        Churchill Downs.
      </p>

      <p>
        While some still dress in fashionable hats, dresses and suits, and
        striking sunshades, many sport jeans and other comfortable attire. Take
        note that it often rains for the derby, so make sure to pack your rain
        gear and an extra pair of shoes.
      </p>

      <p>
        Speaking of hats, why <em>are</em> the fancy Derby hats such a thing?
        Turns out, it’s been a tradition from day one, when Colonel Meriwether
        Lewis Clark Jr., the man that helped to establish the Derby and founded
        Churchill Downs, took a page from the playbook of the English and French
        racing events. Impressed with the well-dressed spectators at these
        events, Clark Jr. and his wife Mary encouraged members of Louisville’s
        well-to-do society to don fancy hats and attire to attend the inaugural
        event—and the tradition stuck.
      </p>

      <div className="blog-callout">
        <strong>Hat tip:</strong> If you’re still looking for the perfect Derby
        hat, check out Derbyologie on Etsy (rush shipping was mentioned in the
        original post).
      </div>

      {/* Replace with your local assets */}
      <figure className="blog-figure">
        <img
          src="/imgs/blog/derby/churchill-barbaro.jpeg"
          alt="Barbaro statue in front of Churchill Downs"
          loading="lazy"
        />
        <figcaption className="blog-figcaption">
          Barbaro statue in front of Churchill Downs
        </figcaption>
      </figure>

      <p>
        Friday night, consider attending The Longines Kentucky Oaks. Also known
        as “Lillies for the Fillies” in honor of the race’s official flower, the
        stargazer lily, this race is held each year on the day before the
        Kentucky Derby.
      </p>

      <p>
        Founded by the same man, in the same place, and in the same year as the
        Kentucky Derby, The Oaks is the second most heavily attended horse race
        in the U.S. following the Triple Crown. But it’s not all just about the
        horses; for several years now, this event has begun with a breast and
        ovarian cancer Survivors Parade. Attendees are encouraged with a fashion
        contest to adorn themselves in pink to show support.
      </p>

      <h2>Hosting a Derby party? Make it fun with some simple tips!</h2>
      <p>
        With over 14 million domestic viewers last year, it’s safe to say that
        watching from the comfort of one’s own home is how many people enjoy the
        race. Pinterest boards abound with ideas for creating your own fun.
        Inviting friends and family, with Derby hats optional, can kick this off
        right.
      </p>

      <p>
        For added fun and encouragement to participate, hold a contest for the
        best and worst hats! Prizes can be a bouquet of roses or a mouth-watering
        treat.
      </p>

      <figure className="blog-figure">
        <img
          src="/imgs/blog/derby/mint-julep.jpeg"
          alt="Mint juleps, official drink for the Kentucky Derby"
          loading="lazy"
        />
        <figcaption className="blog-figcaption">
          Mint juleps, the official drink of the Kentucky Derby
        </figcaption>
      </figure>

      <p>
        Delicious Derby pie, refreshing mint juleps, gooey Kentucky hot brown
        dip, and Louisville’s famous Hot Brown sandwiches are an enticing spread
        found in many homes and restaurants on this day. Think about decorating
        with fresh-cut roses and serving on premier plastic plateware or even
        breaking out the fine china (when else?).
      </p>

      <p>
        But don’t forget the main event— the race! There are a variety of ways
        to stream the event live, and be sure to check out the Derby Day
        schedule and your state’s gambling laws.
      </p>

      <p>
        No matter whether you plan to attend in-person during Kentucky Derby
        Week or from home hosting your crew, with a little forethought, you can
        bet your bottom dollar that you’ll enjoy celebrating this American
        pastime.
      </p>
    </div>
  );
}
